import { render, staticRenderFns } from "./type3.vue?vue&type=template&id=1d5c7a90&scoped=true&"
import script from "./type3.vue?vue&type=script&lang=js&"
export * from "./type3.vue?vue&type=script&lang=js&"
import style0 from "./type3.vue?vue&type=style&index=0&id=1d5c7a90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5c7a90",
  null
  
)

export default component.exports